import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">热门影视作品精选，总有你的菜</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaData.slice(0, 5).map((item) => (
              <a
                key={item.id}
                href="#media"
                className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative overflow-hidden aspect-video">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="800"
                    height="450"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                    {item.category}
                  </span>
                  <span className="absolute top-3 right-3 bg-background-50/90 text-primary-600 text-xs font-bold px-2 py-1 rounded-md flex items-center gap-0.5">
                    <i className="ri-star-fill"></i>
                    {item.rating}
                  </span>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="text-white text-sm md:text-base font-semibold leading-snug line-clamp-2">
                      {item.title}
                    </h3>
                  </div>
                </div>
                <div className="px-4 py-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </span>
                  <span className="text-xs text-primary-600 font-medium cursor-pointer whitespace-nowrap">
                    立即观看 <i className="ri-arrow-right-line ml-0.5"></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}